import Repository from "./Repository";

const formDataConfig = {
  headers: { "Content-Type": "multipart/form-data" }
};

const GET_BY_ROLE = "get";
const GET_BY_PROJECT = "get-by-count";
const GET_BY_PAGE = "get-by-page";
const READ = "read";

export default {
  getByRole(payload) {
    return Repository.post(transformRoute(GET_BY_ROLE), payload);
  },

  getByProject(payload) {
    return Repository.post(transformRoute(GET_BY_PROJECT), payload);
  },

  getByPage(payload) {
    return Repository.post(transformRoute(GET_BY_PAGE), payload);
  },

  read(payload) {
    return Repository.patch(transformRoute(READ), payload);
  }
};

const transformRoute = route => {
  return `/task-manager/notification/${route}`;
};
